export const filterEnabledMemberships = (memberships) => (
  memberships?.filter(({ enabled, _destroy }) => enabled && !_destroy) || []
)
